import React, { useState } from 'react'
import { Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './Persona.styles'
import { labravDefaultThemeV7 as theme } from '@labrav/react-components'
interface PersonaProps {
  memberType: 'admin' | 'allianceLead' | 'integration'
  /** Cloud name shown on the persona, such as AWS or Azure. */
  cloudType: string
  /** When set, overrides the cloud type in titles and hover width. */
  displayLabel?: string
}
const Persona: React.FC<PersonaProps> = ({
  memberType,
  cloudType,
  displayLabel,
}) => {
  const { classes } = useStyles()
  const [isHovered, setIsHovered] = useState(false)
  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  const handleMouseLeave = () => {
    setIsHovered(false)
  }
  const label = displayLabel ?? `${cloudType}`

  let personaTitle: string
  let backgroundColor: string
  if (memberType === 'allianceLead') {
    personaTitle = `${label} alliance lead`
    backgroundColor = theme.palette.avatarColors.blue
  } else if (memberType === 'integration') {
    personaTitle = `${label} integration`
    backgroundColor = theme.palette.avatarColors.blue
  } else {
    personaTitle = `${label} admin`
    backgroundColor = theme.palette.avatarColors.purple
  }
  const getHoverWidth = (
    labelForDisplay: string,
    memberType: 'admin' | 'allianceLead' | 'integration'
  ) => {
    const baseText = 'Requires '
    const roleText =
      memberType === 'allianceLead'
        ? 10
        : memberType === 'integration'
          ? 8.5
          : 5
    const fullText = baseText + labelForDisplay
    const fullTextLength = fullText.length + roleText

    let coefficient: number
    if (labelForDisplay === 'AZURE') {
      coefficient = 0.59
    } else if (labelForDisplay === 'REDHAT') {
      coefficient = 0.6
    } else if (labelForDisplay === 'Salesforce') {
      coefficient = 0.55
    } else {
      coefficient = 0.62
    }
    return coefficient * fullTextLength
  }
  const onHoverWidth = getHoverWidth(label, memberType)
  const width = isHovered ? `${onHoverWidth}em` : '12px'
  return (
    <div
      className={classes.roleBadge}
      style={{ width, backgroundColor }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <FontAwesomeIcon icon={faUser} className={classes.titleUserIcon} />
      {isHovered && (
        <>
          <Typography className={classes.requiredText}>Required</Typography>
          <Typography className={classes.boldText}>{personaTitle}</Typography>
        </>
      )}
    </div>
  )
}
export default Persona
